<div class="body">

    <carousel [cellWidth]="'80%'" [cellsToShow]="1" height="700">

        <ng-container *ngFor="let file of resolvedFiles">

            <div class="carousel-cell msg-preview-wrapper">
                
                <div class="msg-preview-inner">
                    <app-msg-preview [fileName]="file.fileName" [blob]="file.blob"></app-msg-preview>
                </div>

            </div>

        </ng-container>

    </carousel>

</div>